var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.socketIsAuthenticated && !_vm.loading)?_c('div',[_c('chat'),_c('footer-bar',{staticClass:"justify-center"})],1):_c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"300px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"secondary","width":"4","size":"60"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }